import { SliderBtn as SliderBtnCore } from '@studiometa/ui';

/**
 * Slider Btn
 */
export default class SliderBtn extends SliderBtnCore {
  /**
   * Update attributes.
   * @param   {number} index
   * @returns {void}
   */
  update(index) {
    const isContainMaxState =
      this.$parent.$options.contain &&
      this.$parent.containMaxState ===
        this.$parent.getStates()[index].x[this.$parent.$options.mode];
    if (
      (index === 0 && this.$options.prev) ||
      ((index === this.$parent.indexMax || isContainMaxState) && this.$options.next)
    ) {
      this.$el.setAttribute('disabled', '');
    } else {
      this.$el.removeAttribute('disabled');
    }
  }
}
